import React from 'react';

import { Box, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';
import { ModalSection } from '../../../../Shared/components-v2/modal-section/ModalSection';
import { ModalSectionRow } from '../../../../Shared/components-v2/modal-section/ModalSectionRow';
import { urlBuilder } from '../../../../Shared/urlBuilder';
import { EnvelopeAccountSettingsModalQuery } from '../graphql/accountSettingsModal.generated';
import { formatLegalAccountType } from '../helper';

type DirectTradingAccount = NarrowTypename<
  EnvelopeAccountSettingsModalQuery['envelopeAccount'],
  'DirectTradingAccount'
>;

type DirectTradingAccountSettingsProps = {
  envelopeAccount: DirectTradingAccount;
};

export const DirectTradingAccountSettings: React.FC<DirectTradingAccountSettingsProps> = ({ envelopeAccount }) => {
  const { legalAccount } = envelopeAccount;
  const legalAccountType = formatLegalAccountType(legalAccount);
  const hasBeneficiaries = legalAccount.primaryBeneficiaries.length > 0;

  return (
    <Box css={{ display: 'grid', gap: 'space.200' }}>
      <ModalSection header="Account details">
        <ModalSectionRow>
          <ModalSectionRow.LeadingContent>
            <Text>Account type</Text>
          </ModalSectionRow.LeadingContent>
          <ModalSectionRow.TrailingContent>
            <Text>{legalAccountType}</Text>
          </ModalSectionRow.TrailingContent>
        </ModalSectionRow>
        {!hasBeneficiaries && (
          <ModalSectionRow>
            <ModalSectionRow.LeadingContent>
              <Text>Beneficiaries</Text>
            </ModalSectionRow.LeadingContent>
            <ModalSectionRow.TrailingContent>
              <SambaAutoLink to={urlBuilder.getLegalAccounts.absolute()}>Add beneficiary</SambaAutoLink>
            </ModalSectionRow.TrailingContent>
          </ModalSectionRow>
        )}
      </ModalSection>
    </Box>
  );
};
